import ilComponent from './MeshSelect'

export default Vue => {
    Vue.component(ilComponent.name, ilComponent);
}

